import ProjectOverviewPage from "./ProjectOverviewPage.jsx";
import ProjectRequestCreationPage from "./ProjectRequestCreationPage";
import ProjectDetailPage from "./ProjectDetailPage";
import ProjectSearchPage from "./ProjectSearchPage";

const routes = [
  {
    path: "/project/search",
    component: ProjectSearchPage,
    exact: true,
    isAuthProtected: true,
  },
  {
    path: "/project/:id",
    component: ProjectOverviewPage,
    exact: true,
    isAuthProtected: true,
  },
  {
    path: "/project/:id/details",
    component: ProjectDetailPage,
    exact: true,
    isAuthProtected: true,
  },
  {
    path: "/project/request/create",
    component: ProjectRequestCreationPage,
    exact: true,
    isAuthProtected: true,
  },
  {
    path: "/project/request/:requestId",
    component: ProjectRequestCreationPage,
    exact: true,
    isAuthProtected: true,
  },

];

export default routes
